import { z } from 'zod';
import { cursorQuerySchema } from './common';

export const listOrdersQuerySchema = cursorQuerySchema.extend({
  role: z.enum(['buyer', 'seller']).optional(),
  status: z
    .enum([
      'pending_payment',
      'paid',
      'shipped',
      'delivered',
      'confirmed',
      'settled',
      'cancelled',
      'refunded',
      'disputed',
    ])
    .optional(),
});
export type ListOrdersQuery = z.infer<typeof listOrdersQuerySchema>;

/** mock 결제 — PG 어댑터 도입 시 provider/paymentMethod 확장 */
export const payOrderSchema = z.object({
  provider: z.literal('mock').default('mock'),
});

export const createShipmentSchema = z.object({
  carrier: z.string().min(1).max(50),
  trackingNumber: z.string().min(4).max(50),
});
export type CreateShipmentInput = z.infer<typeof createShipmentSchema>;

export const cancelOrderSchema = z.object({
  reason: z.string().max(500).optional(),
});

export const openDisputeSchema = z.object({
  reasonCode: z.enum(['not_received', 'damaged', 'different', 'other']),
  description: z.string().max(4000).optional(),
  evidenceImages: z.array(z.string().max(500)).max(5).default([]),
});
export type OpenDisputeInput = z.infer<typeof openDisputeSchema>;

export const createReviewSchema = z.object({
  rating: z.number().int().min(1).max(5),
  tags: z.array(z.string().max(30)).max(5).default([]),
  comment: z.string().max(1000).optional(),
});
export type CreateReviewInput = z.infer<typeof createReviewSchema>;
